import { Bar, mixins } from "vue-chartjs"
import numeral from "numeral"

export default Bar.extend({
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        displayMode: {
            type: String,
            required: false
        },
        yMax: {
            type: Number,
            default: 0
        }
    },
    watch: {
        yMax: {
            handler (newOption, oldOption) {
                this._chart.destroy()
                this.renderChart(this.chartData, this.options)
            },
            deep: true
        }
    },
    methods: {
        click (event) {
            try {
                const chart_element = this._chart.getElementAtEvent(event)[0]
                const project = this._chart.config.data.datasets[chart_element._datasetIndex].project
                this.$emit("click", project.id, event)
            } catch (e) {}
        }
    },
    computed: {
        options () {
            return {
                onClick: this.click,
                tooltips: {
                    callbacks: {
                        label: (tooltipItem, data) => {
                            let total_hours = 0
                            data.datasets.forEach(dataset => {
                                total_hours += parseFloat(dataset.data[tooltipItem.index])
                            })
                            const value_numeral = numeral(tooltipItem.yLabel)
                            let unit = "h"
                            if(this.displayMode === "relative") unit = "%"
                            return data.datasets[tooltipItem.datasetIndex].label + ": " + value_numeral.format("0,0.0") + unit + " / " + numeral(total_hours).format("0,0.0") + unit
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            suggestedMax: this.yMax,
                            fontColor: "#00274F",
                            callback: (value, index, values) => {
                                if(this.displayMode === "relative") return numeral(value).format("0,0") + "%"
                                return numeral(value).format("0,0") + "h"
                            }
                        },
                        gridLines: {
                            display: true,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        gridLines: {
                            display: false,
                            color: "rgba(0, 39, 79, 0.1)"
                        },
                        categoryPercentage: 0.9,
                        barPercentage: 0.8
                    }]
                },
                legend: {
                    display: false,
                    position: "right",
                    labels: {
                        fontSize: 11,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 14,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
})
